var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarimg7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "events-svgrepo-com",
    transform: "translate(0.361 0.362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5551",
    "data-name": "Group 5551",
    transform: "translate(3.132 1.737)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14591",
    "data-name": "Path 14591",
    d: "M27.763,7.4V23.681a4.569,4.569,0,0,1-4.652,4.652H5.9a3.11,3.11,0,0,0,3.1,3.1H24.662a6.221,6.221,0,0,0,6.2-6.2V10.5A3.11,3.11,0,0,0,27.763,7.4Z",
    transform: "translate(0.147 2.369)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5550",
    "data-name": "Group 5550"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14592",
    "data-name": "Path 14592",
    d: "M6.652,1.1V4.2H5.1A3.11,3.11,0,0,0,2,7.3V25.909a3.11,3.11,0,0,0,3.1,3.1H24.018a3.11,3.11,0,0,0,3.1-3.1V7.3a3.11,3.11,0,0,0-3.1-3.1H22.468V1.1h-3.1V4.2H9.753V1.1ZM5.1,11.954H24.018V25.909H5.1Z",
    transform: "translate(-2 -1.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14593",
    "data-name": "Path 14593",
    d: "M17.114,20.319l-3.721-2.171L9.826,20.319l.93-4.187L7.5,13.342l4.342-.31L13.547,9l1.706,3.876,4.342.465-3.256,2.791Z",
    transform: "translate(1.028 3.25)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2469",
    "data-name": "Rectangle 2469",
    width: 38,
    height: 38,
    transform: "translate(-0.361 -0.362)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarimg7);
export default __webpack_public_path__ + "static/media/sidebarimg7.e1b4918400b9f1e430efd644e0b46a79.svg";
export { ForwardRef as ReactComponent };